import request from '../../../Helpers/Request';

class Categories {
    constructor(settings) {
        this.settings = settings;
    }

    getItemsFromWebshop(id) {
        return new Promise((resolve, reject) => {
            request('GET', `/clients/connections/${id}/categories/webshops`, this.settings)
                .then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
        });
    }

    getItemsFromFeed(id) {
        return new Promise((resolve, reject) => {
            request('GET', `/clients/connections/${id}/categories/feeds`, this.settings)
                .then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
        });
    }

    getCombined(id) {
        return new Promise((resolve, reject) => {
            request('GET', `/clients/connections/${id}/categories`, this.settings)
                .then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
        });
    }

    update(id, data) {
        return new Promise((resolve, reject) => {
            request('PUT', `/clients/connections/${id}/categories`, this.settings, data)
                .then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
        });
    }

    updateItemInWebshop(connectionId, categoryId, data) {
        return new Promise((resolve, reject) => {
            request('PUT', `/clients/connections/${connectionId}/categories/webshops/${categoryId}`, this.settings, data)
                .then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
        });
    }

    createItemInWebshop(connectionId, data) {
        return new Promise((resolve, reject) => {
            request('POST', `/clients/connections/${connectionId}/categories/webshops`, this.settings, data)
                .then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
        });
    }

    deleteItemInWebshop(connectionId, categoryId) {
        return new Promise((resolve, reject) => {
            request('DELETE', `/clients/connections/${connectionId}/categories/webshops/${categoryId}`, this.settings)
                .then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
        });
    }
}

export default Categories;
